export default __webpack_public_path__ + "static/media/CHEVRON_ICONA_UP.0cdd79d9.svg";